module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/trash-f202b450934d15cca220e6490dd0ae08.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/trash.svg
// module id = eFKq
// module chunks = 24